import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";
import { AssistantAvatarFacialHair } from "../../assistantAvatarConfig";

const BEARD_PATH = "M36 62 C36 80 46 90 60 90 C74 90 84 80 84 62 C80 72 74 76 70 76 Q60 80 50 76 C46 76 40 72 36 62Z";
const MUSTACHE_PATH = "M50 67.5 Q55 64 60 67 Q65 64 70 67.5 Q65 70.5 60 69 Q55 70.5 50 67.5Z";

type FacialHairLayer = FC<{ color: string }>;

const FACIAL_HAIR: Record<AssistantAvatarFacialHair, FacialHairLayer | null> = {
	[AssistantAvatarFacialHair.None]: null,
	[AssistantAvatarFacialHair.Stubble]: ({ color }) => <path d={BEARD_PATH} fill={color} opacity={ASSISTANT_AVATAR.OPACITY.STUBBLE} />,
	[AssistantAvatarFacialHair.Beard]: ({ color }) => <path d={BEARD_PATH} fill={color} />,
	[AssistantAvatarFacialHair.Mustache]: ({ color }) => <path d={MUSTACHE_PATH} fill={color} />,
};

export const HumanFacialHair: FC<{ variant: AssistantAvatarFacialHair; color: string }> = ({ variant, color }) => {
	const Layer = FACIAL_HAIR[variant];
	return Layer ? <Layer color={color} /> : null;
};
